export const formatDate = (datetime) => {
    const date = new Date(datetime)
    const month = date.getMonth() + 1
    return month > 10 ? date.getDate() + '/' + month + '/' + date.getFullYear() : date.getDate() + '/'+ + "0" + month + '/' + date.getFullYear()
}
export const formatDateFilter = (datetime) => {
    const date = new Date(datetime)
    const month = date.getMonth() + 1
    return date.getDate() + '-' + +"0" + month + '-' + date.getFullYear()
}